import {noop} from "lodash";
import {
    ASN_Information,
    Cancel_ASN,
    Cancel_ASN_Batch,
    Cancel_ASN_Batch_v2,
    Cancel_ASN_v2,
    Cancel_Wholesale_Batch,
    Change_ASN_Audit,
    Change_ASN_Status,
    Change_ASN_Submit,
    Change_ASN_Submit_v2,
    Change_Customer_Active,
    Check_Customer_Id,
    Check_Inbound_From_Order_No,
    Create_ASN,
    Create_ASN_v2,
    Customer_Choice,
    Customer_Information,
    Download_Product_Template,
    Edit_ASN,
    Edit_ASN_v2,
    Edit_Customer,
    Edit_Submit_ASN,
    Edit_Submit_ASN_v2,
    Export_Hung_Up,
    Export_Inbound,
    Export_Inbound_Details_By_Filter,
    Export_Inventory_Product,
    Filter_ASN,
    Inbound_Warehouse_list,
    Remove_Multi_Address, Return_Cancel_Label, Return_Get_Label,
    Return_Get_Rate, Return_Label_Generate_Receive,
    Save_Submit_Inbound_ASN,
    Save_Submit_Inbound_ASN_v2,
    Save_Submit_Return_ASN,
    Sku_Choice,
    Submit_ASN_Batch,
    Submit_ASN_Batch_v2,
    Submit_Wholesale_Batch,
    Warehouse_List_Owner,
    Withdraw_ASN,
    Withdraw_Wholesale
} from "../../config";
import api from "../../api/api";
import LocalStorage from "../../utils/LocalStorage";
import {InventoryActionType} from "../inventory/inventoryAction";
import { v4 as uuidv4 } from 'uuid';
import moment from "moment/moment";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";
import progressApi from "../../api/progressApi";
import {OutBoundsActionType} from "../outbounds/outboundsAction";
export const InboundsActionType = {
    INBOUNDS_SEARCH_LIST:'INBOUNDS_SEARCH_LIST',
    CUSTOMER_LIST:'CUSTOMER_LIST'
}


export const inboundsFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.InboundDataList)) return null;
        const url = `${Filter_ASN}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        onError(e.message)
    }

}

export const change_asn_status = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InboundDataChange)) return null;
        const url = `${Change_ASN_Status}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url,requestData)
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(`InboundPage.Update ASN status successfully`)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const inboundWithdraw = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        // if (!checkPermission(PERMISSION_DICT.OutboundWholesaleChange)) return null;
        const url = `${Withdraw_ASN}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(`InboundPage.Withdraw inbound order successfully`)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}



export const change_asn_status_submit = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.InboundDataSubmit)) return null;
        let url = ""

        if (checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            url = data?.ownerId?.startsWith('NS') ? `${Change_ASN_Submit_v2}` : `${Change_ASN_Submit}`
        }else {
            const ownerId = LocalStorage.getItem("ownerId")
            url = ownerId && ownerId.startsWith('NS') ? `${Change_ASN_Submit_v2}` : `${Change_ASN_Submit}`
        }
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url,requestData)
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(`InboundPage.Update ASN status successfully`)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}


// export const change_asn_status_audit = (data,onSuccess = noop, onError = noop) => async dispatch => {
//     try {
//
//         if (!checkPermission(PERMISSION_DICT.InboundDataAudit)) return null;
//         const url = `${Change_ASN_Audit}`
//         let requestData = {...data}
//         delete requestData.userName
//         const response = await api.post(url,requestData)
//             .then(res=>res)
//
//
//         if(response?.status === 200 && response.data.code === 200){
//
//             onSuccess(`Update ${response.data.msg} ASN status successfully`)
//         } else {
//
//             onError(response.data.msg)
//         }
//
//     } catch (e) {
//         onError(e.message)
//     }
// }



export const customer_choice = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.CustomerChoiceAddress)) return null;
        const url = `${Customer_Choice}`
        let requestData = {...data}
        requestData.ownerId = data.ownerId? data.ownerId: ""
        delete requestData.userName
        const response = await api.post(url,requestData)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            let arr = response.data.data.map((item, index) => {
                return { ...item, id: index + 1 };
            });

            dispatch({
                type:InboundsActionType.CUSTOMER_LIST,
                payload:arr
            })
            onSuccess(response.data.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const customer_choice_filter = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.CustomerChoiceAddress)) return null;
        const url = `${Customer_Choice}`
        let requestData = {...data}
        requestData.ownerId = data.ownerId? data.ownerId: ""
        delete requestData.userName
        const response = await api.post(url,requestData)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            let arr = response.data.data.map((item, index) => {
                return { ...item, id: index + 1 };
            });
            onSuccess(arr)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}




export const ASNInfo = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InboundDataInfo)) return null;

        const url = `${ASN_Information}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url,requestData)
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.data)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {

        onError(e.message)
    }
}


export const editASN = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InboundDataModify)) return null;
        // const url = `${Edit_ASN}`
        let url = ""

        if (checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            url = data?.ownerId?.startsWith('NS') ? `${Edit_ASN_v2}` : `${Edit_ASN}`
        }else {
            const ownerId = LocalStorage.getItem("ownerId")
            url = ownerId && ownerId.startsWith('NS') ? `${Edit_ASN_v2}` : `${Edit_ASN}`
        }

        const response = await api.post(url, {...data})
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess(`InboundPage.Edit ASN Successfully`)
        } else {

            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {

        onError(e.message)
    }
}


export const editAndSubmitASN = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.InboundDataSubmit)) return null;
        // const url = `${Edit_Submit_ASN}`
        let url = ""

        if (checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            url = data?.ownerId?.startsWith('NS') ? `${Edit_Submit_ASN_v2}` : `${Edit_Submit_ASN}`
        }else {
            const ownerId = LocalStorage.getItem("ownerId")
            url = ownerId && ownerId.startsWith('NS') ? `${Edit_Submit_ASN_v2}` : `${Edit_Submit_ASN}`
        }
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess('InboundPage.Inbound order edited and submitted successfully')
        } else {

            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {
        console.log(e)
        onError(e.message)
    }
}


export const downloadInboundTemplate = (onSuccess= noop, onError = noop) => async () =>{

    try{

        if (!checkPermission(PERMISSION_DICT.TemplateFileDownload)) return null;
        const xurl = `${Download_Product_Template}`
        const customer = !checkPermission(PERMISSION_DICT.QueryOwnerInfo)
        const fileName = customer ? 'Customer_Inbound_Template.xlsx':'Inbound_Template.xlsx'
        const response = await api.get(xurl,{params: { fileName: fileName },
            responseType: 'blob' })


        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Inbound_Template_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            console.error('Failed to download file. Server responded with status:', response.status);
            onError(`Failed to download file. Server responded with status:${response.status}`)
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}



export const downloadInboundInfo = (data,onSuccess= noop,onError = noop) => async () =>{

    try {

        if (!checkPermission(PERMISSION_DICT.InboundDataExport)) return null;
        const xurl = `${Export_Inbound}`;
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(xurl, requestData, {
            responseType: 'blob' // 设置响应类型为 Blob
        });



        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Inbound_Information_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const downloadInboundDetailInfoFilter = (data,onSuccess= noop,onError = noop) => async () =>{

    try {

        if (!checkPermission(PERMISSION_DICT.InboundDataExport)) return null;
        const xurl = `${Export_Inbound_Details_By_Filter}`;
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(xurl, requestData, {
            responseType: 'blob' // 设置响应类型为 Blob
        });



        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Inbound_Information_With_Details_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}


export const downloadHungUpList = (data,onSuccess= noop,onError = noop) => async () =>{

    try {

        if (!checkPermission(PERMISSION_DICT.DashBoardDataList)) return null;
        const xurl = `${Export_Hung_Up}`;
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(xurl, requestData, {
            responseType: 'blob' // 设置响应类型为 Blob
        });

        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Hung_Up_Information_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const createASN = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.InboundDataAdd)) return null;
        // const url = `${Create_ASN}`
        let url = ""
        if (checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            url = data?.ownerId?.startsWith('NS') ? `${Create_ASN_v2}` : `${Create_ASN}`
        }else {
            const ownerId = LocalStorage.getItem("ownerId")
            url = ownerId && ownerId.startsWith('NS') ? `${Create_ASN_v2}` : `${Create_ASN}`
        }

        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.msg)
        } else {

            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {
        console.log(e)
        onError(e.message)
    }
}

export const saveAndSubmitASN = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.InboundDataAddReturn)) return null;
        const url = `${Save_Submit_Return_ASN}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.msg)
        } else {

            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {
        console.log(e)
        onError(e.message)
    }
}

export const saveAndSubmitInboundASN = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.InboundDataSubmit)) return null;
        // const url = `${Save_Submit_Inbound_ASN}`
        let url = ""

        if (checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            url = data?.ownerId?.startsWith('NS') ? `${Save_Submit_Inbound_ASN_v2}` : `${Save_Submit_Inbound_ASN}`
        }else {
            const ownerId = LocalStorage.getItem("ownerId")
            url = ownerId && ownerId.startsWith('NS') ? `${Save_Submit_Inbound_ASN_v2}` : `${Save_Submit_Inbound_ASN}`
        }
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess('InboundPage.Inbound order created and submitted successfully')
        } else {

            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {
        console.log(e)
        onError(e.message)
    }
}


export const cancelASN = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InboundDataDelete)) return null;

        // const url = `${Cancel_ASN}`
        let url = ""

        if (checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            url = data?.ownerId?.startsWith('NS') ? `${Cancel_ASN_v2}` : `${Cancel_ASN}`
        }else {
            const ownerId = LocalStorage.getItem("ownerId")
            url = ownerId && ownerId.startsWith('NS') ? `${Cancel_ASN_v2}` : `${Cancel_ASN}`
        }
        let requestData = {...data}
        delete requestData.userName
        const response = await progressApi.post(url,requestData)
            .then(res=>res)

        if(response?.status === 200 && response.data?.data?.code === 200){

            onSuccess(`InboundPage.Cancel Inbound Successfully`)
        } else {
            let errorMsg = ""
            if (!!response?.data?.msg && response?.data?.msg !== "操作成功"){
                errorMsg += response.data?.msg
            }
            if (!!response?.data?.data?.msg){
                errorMsg += response?.data?.data?.msg
            }

            onError(errorMsg,response?.data.code)
        }

    } catch (e) {
        console.log(e)
        onError(e.message)
    }
}

export const inbound_warehouse_List = (onSuccess = noop,onError = noop)  => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.InboundWarehouseList)) return null;
        const url = `${Inbound_Warehouse_list}`
        const response = await api.get(url)
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {

        onError(e.message)
    }

}

export const inboundBatchSubmit = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InboundDataSubmit)) return null;
        const url = `${Submit_ASN_Batch}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response?.data?.data)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const inboundBatchSubmit_v2 = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InboundDataSubmit)) return null;
        const url = `${Submit_ASN_Batch_v2}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response?.data?.data)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const inboundBatchCancel = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InboundDataDelete)) return null;
        const url = `${Cancel_ASN_Batch}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response?.data?.data)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const inboundBatchCancel_v2 = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InboundDataDelete)) return null;
        const url = `${Cancel_ASN_Batch_v2}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response?.data?.data)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const check_inbound_from_order_no = (data,onSuccess = noop, onError = noop)  => async () => {
    try{

        if (!checkPermission(PERMISSION_DICT.InboundCheckUnique)) return null;
        const url = `${Check_Inbound_From_Order_No}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(true)

        } else if((response?.status === 200 && response.data.code === 500)){
            onSuccess(false)
        }
        else {
            onError(response?.data?.msg)
        }
    } catch (e) {
        onError(e.message)
    }
}


export const label_get_rate = (data,onSuccess = noop, onError = noop)  => async () => {
    try{

        // if (!checkPermission(PERMISSION_DICT.ReturnGetRate)) return null;
        const url = `${process.env.REACT_APP_DARWYNNSHIPPER_URL}${Return_Get_Rate}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response?.data?.data)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const shipper_get_label = (data,onSuccess = noop, onError = noop)  => async () => {
    try{

        // if (!checkPermission(PERMISSION_DICT.ReturnGetRate)) return null;
        const url = `${process.env.REACT_APP_DARWYNNSHIPPER_URL}${Return_Get_Label}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response?.data?.data)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const shipper_cancel_label = (data,onSuccess = noop, onError = noop)  => async () => {
    try{

        // if (!checkPermission(PERMISSION_DICT.ReturnGetRate)) return null;
        const url = `${process.env.REACT_APP_DARWYNNSHIPPER_URL}${Return_Cancel_Label}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response?.data?.data)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}


export const return_label_generate_receive = (data,onSuccess = noop, onError = noop)  => async () => {
    try{

        if (!checkPermission(PERMISSION_DICT.InboundDataAdd)) return null;
        const url = `${Return_Label_Generate_Receive}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(true)

        } else if((response?.status === 200 && response.data.code === 500)){
            onSuccess(false)
        }
        else {
            onError(response?.data?.msg)
        }
    } catch (e) {
        onError(e.message)
    }
}